// extracted by mini-css-extract-plugin
module.exports =  {"root":"ccxQWzPgW4MpdixMLtBS","alert":"Q8rKzNwNqv2p6rgQHGke","tooltip":"dYO5y5F0OQz_nux4BeOf","infoIcon":"Rxl6Udrde8BozEnji9jH"};